
import { api } from '../utils/request';

// 定义用户相关的 API 接口
export const APIWeb = {
  // 发送验证码
  sendCode: (params: SendCodeRequest) => {
    return api.post<SendCodeResponse>('/web/member/send_code', params);
  },

  // 注册
  register: (params: RegisterRequest) => {
    return api.post<RegisterResponse>('/wpay/web/member/register', params);
  },

  // 登录
  login: (params: LoginRequest) => {
    return api.post<LoginResponse>('/web/login/login', params);
  },

  // 获取用户信息
  getUserInfo: () => {
    return api.post<MemberInfoResponse>('/wpay/web/member/info');
  },

  // 获取可充值的链
  getRechargeableChains: () => {
    return api.post<any>('/web/cobo/token_select');
  },

  // 获取钱包地址
  getAddress: (params: MemberAddressRequest) => {
    return api.post<MemberAddressResponse>('/web/member/address', params);
  },

  // 获取充值流水
  getDepositRecords: (params: TransactionListRequest) => {
    return api.post<TransactionListResponse>('/web/cobo/list', params);
  },

  // 获取虚拟卡信息
  getElectronicCardInfo: () => {
    return api.post<any>('/web/card/info');
  },

  // 获取实体卡信息
  getPhysicalCardInfo: () => {
    return api.post<PhysicalCardInfoResponse>('/web/card/physical_info');
  },

  // 虚拟卡开卡
  applyElectronicCard: (params: ApplyCardRequest) => {
    return api.post<any>('/web/card/card_apply', params);
  },

  // 实体卡开卡
  applyPhysicalCard: (params: ApplyCardPhysicalRequest) => {
    return api.post<any>('/web/card/physical_card_apply', params);
  },

  // 卡片资金记录
  getCardRecords: (params: CardRecordsRequest) => {
    return api.post<CardRecordsResponse>('/web/card/card_transaction_list', params);
  },

  //CVV查看
  getCVV: (params: GetCVVRequest) => {
    return api.post<GetCVVResponse>('/web/card/cvv_view', params);
  },

  // 获取资产流水列表
  getAssetFlowList: (params: AssetFlowListRequest) => {
    return api.post<AssetFlowListResponse>('/web/member/asset_flow_list', params);
  },

  // kyc申请
  applyKyc: (params: ApplyKycRequest) => {
    return api.post<any>('/web/kyc/apply', params);
  },

  // 文件上传
  s3uploadFile: (params: UploadFileRequest) => {
    return api.post<UploadFileResponse>('/web/common/s3_upload_url', params);
  },

  // 同步卡片状态
  syncCardStatus: () => {
    return api.post<BaseCardInfo>('/web/card/sync_card_status');
  },

  // 卡片冻结
  freezeCard: () => {
    return api.post<any>('/web/card/freeze');
  },

  // 卡片解冻
  unfreezeCard: () => {
    return api.post<any>('/web/card/unfreeze');
  },

  // 同步卡限额
  syncCardVelocity: () => {
    return api.post<CardGroupResponse>('/web/card/sync_velocity');
  },

  // 卡片限额修改
  updateCardVelocity: (params: CardUpdateLimitRequest) => {
    return api.post<CardUpdateLimitResponse>('/web/card/update_limit', params);
  },

  // 获取谷歌验证器二维码
  getGoogleAuthQRCode: () => {
    return api.post<GoogleAuthQRCodeResponse>('/web/member/google_auth_qr_code');
  },

  // 绑定谷歌验证器
  bindGoogleAuth: (params: BindGoogleAuthRequest) => {
    return api.post<any>('/web/member/bind_google_auth', params);
  },
  // 变更邮箱
  changeEmail: (params: ChangeEmailRequest) => {
    return api.post<any>('/web/member/change_contact', params);
  },

  // 更改旧Account校验Code
  verifyOldAccountCode: (params: VerifyAccountCodeRequest) => {
    return api.post<VerifyAccountCodeResponse>('/web/member/verify_code', params);
  },

  // 变更新Account校验Code
  verifyNewAccountCode: (params: ChangeContactRequest) => {
    return api.post<any>('/web/member/change_contact', params);
  },

  // 忘记密码
  forgotPassword: (params: ForgotPasswordRequest) => {
    return api.post<any>('/web/member/password_reset', params);
  },

  // 忘记密码校验Code
  verifyForgotPasswordCode: (params: VerifyAccountCodeRequest) => {
    return api.post<VerifyAccountCodeResponse>('/web/member/verify_code_un_login', params);
  },

  // 添加收款账户
  addReceivingAccount: (params: AddReceivingAccountRequest) => {
    return api.post<any>('/web/payment_account/add', params);
  },

  // 收款账户列表
  getReceivingAccountList: (params: GetReceivingAccountListRequest) => {
    return api.post<GetReceivingAccountListResponse>('/web/payment_account/list', params);
  },

  // 开卡添加邮寄地址
  addShippingAddress: (params: AddShippingAddressRequest) => {
    return api.post<any>('/web/shipping_address/add', params);
  },

  // 查看开卡邮寄地址
  getShippingAddress: () => {
    return api.post<GetShippingAddressResponse>('/web/shipping_address/list');
  },

  // 兑换
  exchange: (params: ExchangeRequest) => {
    return api.post<any>('/web/exchange/exchange', params);
  },

  // 获取兑换记录
  getExchangeRecord: (params: GetExchangeRecordRequest) => {
    return api.post<GetExchangeRecordResponse>('/web/exchange/list', params);
  },

  // 推广中心
  getPromotionCenter: () => {
    return api.post<GetPromotionCenterResponse>('/wpay/web/member/invite_center');
  },

  // 推广列表
  getPromotionList: (params: GetPromotionListRequest) => {
    return api.post<GetPromotionListResponse>('/wpay/web/member/direct_invite_list', params);
  },
  // 商家配置
  getMerchantConfig: () => {
    return api.post<GetBusinessConfigResponse>('/web/merchant/config');
  },

  // 汇款
  remittance: (params: RemittanceRequest) => {
    return api.post<any>('/web/transfer/create', params);
  },

  // 汇款记录
  getRemittanceRecord: (params: GetRemittanceRecordRequest) => {
    return api.post<GetRemittanceRecordResponse>('/web/transfer/list', params);
  },

  // 检测账户注册状态
  checkAccountStatus: (params: CheckAccountStatusRequest) => {
    return api.post<CheckAccountStatusResponse>('/web/member/check_account', params);
  },

  // 检查邀请码
  checkInviteCode: (params: VerifyInviteCodeRequest) => {
    return api.post<VerifyInviteCodeResponse>('/wpay/web/member/verify_invite_code', params);
  },

  // 领取推广收益
  getPromotionIncome: (params: GetPromotionIncomeRequest) => {
    return api.post<any>('/wpay/web/member/claim_wusd', params);
  }
};

